import {
  Box,
  Button,
  ButtonGroup,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  styled,
  tooltipClasses,
} from "@mui/material";
import styles from "../../styles/pages/user/managerdashboard/manager-dashboard-notification.module.scss";
import React, { Fragment } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import DoubleCheckIcon from "../../ui/Icons/DoubleCheckIcon";
import BookmarkIcon from "../../ui/Icons/BookmarkIcon";
import RemoveIcon from "../../ui/Icons/RemoveIcon";
import NotificationNoItemIcon from "../../ui/Icons/NotificationNoItemIcon";
import Notiuserbatch from "../../public/assets/images/noti-userbatch.svg";
import Notiattach from "../../public/assets/images/noti-attach.svg";
import Notibuyer from "../../public/assets/images/noti-buyer.svg";
import Noticheck from "../../public/assets/images/noti-check.svg";
import Noticopy from "../../public/assets/images/noti-copy.svg";
import Noticopywritter from "../../public/assets/images/noti-copywritter.svg";
import Noticross from "../../public/assets/images/noti-cross.svg";
import Notidoubleuser from "../../public/assets/images/noti-doubleuser.svg";
import Notieditor from "../../public/assets/images/noti-editor.svg";
import Notiglobe from "../../public/assets/images/noti-globe.svg";
import Notimoreuser from "../../public/assets/images/noti-moreuser.svg";
import Notiusernote from "../../public/assets/images/noti-usernote.svg";
import Notiusersetting from "../../public/assets/images/noti-usersetting.svg";
import Notivideo from "../../public/assets/images/noti-video.svg";
import Notivideocut from "../../public/assets/images/noti-videocut.svg";
import Notitipalti from "../../public/assets/images/noti-tipalti.png";
import msgQc from "../../public/assets/images/msg-qc.svg";
import msgResolve from "../../public/assets/images/msg-resolve.svg";
import msgReopen from "../../public/assets/images/msg-reopen.svg";
import msgEditor from "../../public/assets/images/msg-editor.svg";
import managerOpen from "../../public/assets/images/manager-open.svg";
import managerReopen from "../../public/assets/images/manager-reopen.svg";
import managerResolve from "../../public/assets/images/manager-resolve.svg";
import managerRespond from "../../public/assets/images/manager-respond.svg";
import ArchiveNoItemicon from "../../ui/Icons/ArchiveNoItemicon";
import FilterNoResultIcon from "../../ui/Icons/FilterNoResultIcon";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
} from "../../lib/functions/utils.lib";
import assest from "../../json/assest";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#F6F6F6",
    maxWidth: 220,
    borderRadius: "120px 100px 100px 0",
    padding: 0,
    minWidth: "74px",
    minHeight: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 0 -6px 15px !important",

    "& .MuiTypography-root": {
      fontWeight: "500",
      fontSize: "12px",
      color: "#000",
      textAlign: "center",
    },
  },
}));

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManagerNotificationTab = ({
  search,
  notificationTypeList,
  date,
  notifiactionsList,
  notifiactionsListIsLoading,
  updateNotificationSeen,
  updateNotificationArchive,
  updateNotificationReadAll,
  updateNotificationArchiveAll,
  updateNotificationDelete,
  updateNotificationDeleteAll,
  setFilterArchive,
  hasNextPage,
  fetchNextPage,
}) => {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    setFilterArchive(newValue);
  };

  console.warn(notifiactionsList?.[0]?.data?.meta);

  return (
    <>
      <Box className={styles.tbpanel_notificate}>
        <Stack
          direction="row"
          alignItems="center"
          flexWrap="wrap"
          justifyContent="space-between"
          className={styles.notificationTabsHeader}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <Tab label="All Notifications" {...a11yProps(0)} />
            <Tab label="Archive" {...a11yProps(1)} />
          </Tabs>
          {value == 0 ? (
            <ButtonGroup>
              <Button
                startIcon={<DoubleCheckIcon />}
                onClick={updateNotificationReadAll}
              >
                Mark all as read
              </Button>
              <Button
                startIcon={<BookmarkIcon />}
                onClick={updateNotificationArchiveAll}
              >
                Archive all
              </Button>
            </ButtonGroup>
          ) : (
            <ButtonGroup>
              <Button
                startIcon={<RemoveIcon />}
                onClick={updateNotificationDeleteAll}
              >
                Remove all
              </Button>
            </ButtonGroup>
          )}
        </Stack>
      </Box>
      <PerfectScrollbar className={styles.notificationBodyScroll}>
        <Box className={styles.tbpanel_btms}>
          <Paper elevation={0} className={styles.tabPanelPaper}>
            <TabPanel value={value} index={0}>
              {notifiactionsListIsLoading ? (
                "hhhhh"
              ) : notifiactionsList?.[0]?.data?.meta?.total ? (
                // <PerfectScrollbar className={styles.notificationBodyScroll}>
                <List className={styles.notifiactionList}>
                  {notifiactionsList?.map((group, index) => (
                    <Fragment key={index}>
                      {group?.data?.data?.map((item, index) => {
                        return (
                          <ListItem key={index} className={styles.listStyled}>
                            <Grid
                              container
                              spacing={0}
                              className={styles.overlayBg}
                            >
                              <Grid item md={9}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  className={styles.mediaLeft}
                                >
                                  <figure>
                                    <img
                                      src={getAbsoluteImageURI(item?.icon)}
                                      width="26"
                                      height="26"
                                      alt="icon"
                                    />
                                  </figure>
                                  <Box className={styles.mediaAddress}>
                                    <Typography variant="subtitle1">
                                      {item?.title}
                                    </Typography>
                                    {item?.old_value || item?.new_value ? (
                                      <List>
                                        <ListItem>
                                          From:
                                          {item?.old_value}
                                        </ListItem>
                                        <ListItem>
                                          To:
                                          {item?.new_value}
                                        </ListItem>
                                      </List>
                                    ) : (
                                      ""
                                    )}
                                    <Typography variant="caption">
                                      {getStyledDateTime(item?.updated_at)}
                                    </Typography>
                                  </Box>
                                </Stack>
                              </Grid>
                              <Grid item md={3}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  justifyContent="flex-end"
                                  className={styles.mediaRight}
                                >
                                  {item?.seen ? (
                                    item?.archive ? (
                                      <HtmlTooltip
                                        title={
                                          <React.Fragment>
                                            <Typography color="inherit">
                                              Remove
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        placement="top-start"
                                      >
                                        <img
                                          onClick={() =>
                                            updateNotificationDelete(item)
                                          }
                                          src={assest.crossGray}
                                          width={9}
                                          height={9}
                                          alt="icon"
                                        />
                                      </HtmlTooltip>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateNotificationArchive(item)
                                        }
                                      >
                                        Archive
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      onClick={() =>
                                        updateNotificationSeen(item)
                                      }
                                    >
                                      Mark as read
                                    </Button>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  ))}

                  {hasNextPage ? (
                    <Box className={styles.viewmoreBtnStyled}>
                      <Button onClick={fetchNextPage}>View more</Button>
                    </Box>
                  ) : (
                    ""
                  )}
                </List>
              ) : // </PerfectScrollbar>
              search?.length ||
                notificationTypeList?.length ||
                date?.startDate?.length ||
                date?.endDate?.length ? (
                <Box className={styles.filterNoResult}>
                  <FilterNoResultIcon />
                  <Typography variant="body1">
                    We couldn't find any matches for the selected filter(s).
                  </Typography>
                  <Button>Reset filters</Button>
                </Box>
              ) : (
                <Stack className={styles.noItems}>
                  <NotificationNoItemIcon />
                  <Typography variant="body1">
                    You're all clear - no new notifications
                  </Typography>
                </Stack>
              )}
            </TabPanel>
            <TabPanel value={value} index={1}>
              {notifiactionsListIsLoading ? (
                ""
              ) : notifiactionsList?.[0]?.data?.meta?.total ? (
                // <PerfectScrollbar className={styles.notificationBodyScroll}>
                <List className={styles.notifiactionList}>
                  {notifiactionsList?.map((group, index) => (
                    <Fragment key={index}>
                      {group?.data?.data?.map((item, index) => {
                        return (
                          <ListItem key={index} className={styles.listStyled}>
                            <Grid
                              container
                              spacing={0}
                              className={styles.overlayBg}
                            >
                              <Grid item md={9}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  className={styles.mediaLeft}
                                >
                                  <figure>
                                    <img
                                      src={getAbsoluteImageURI(item?.icon)}
                                      width="26"
                                      height="26"
                                      alt="icon"
                                    />
                                  </figure>
                                  <Box className={styles.mediaAddress}>
                                    <Typography variant="subtitle1">
                                      {item?.title}
                                    </Typography>
                                    {item?.old_value || item?.new_value ? (
                                      <List>
                                        <ListItem>
                                          From:
                                          {item?.old_value}
                                        </ListItem>
                                        <ListItem>
                                          To:
                                          {item?.new_value}
                                        </ListItem>
                                      </List>
                                    ) : (
                                      ""
                                    )}
                                    <Typography variant="caption">
                                      {getStyledDateTime(item?.updated_at)}
                                    </Typography>
                                  </Box>
                                </Stack>
                              </Grid>
                              <Grid item md={3}>
                                <Stack
                                  direction="row"
                                  flexWrap="wrap"
                                  justifyContent="flex-end"
                                  className={styles.mediaRight}
                                >
                                  {item?.seen ? (
                                    item?.archive ? (
                                      <HtmlTooltip
                                        title={
                                          <React.Fragment>
                                            <Typography color="inherit">
                                              Remove
                                            </Typography>
                                          </React.Fragment>
                                        }
                                        placement="top-start"
                                      >
                                        <img
                                          onClick={() =>
                                            updateNotificationDelete(item)
                                          }
                                          src={assest.crossGray}
                                          width={9}
                                          height={9}
                                          alt="icon"
                                        />
                                      </HtmlTooltip>
                                    ) : (
                                      <Button
                                        onClick={() =>
                                          updateNotificationArchive(item)
                                        }
                                      >
                                        Archive
                                      </Button>
                                    )
                                  ) : (
                                    <Button
                                      onClick={() =>
                                        updateNotificationSeen(item)
                                      }
                                    >
                                      Mark as read
                                    </Button>
                                  )}
                                </Stack>
                              </Grid>
                            </Grid>
                          </ListItem>
                        );
                      })}
                    </Fragment>
                  ))}

                  {hasNextPage ? (
                    <Box className={styles.viewmoreBtnStyled}>
                      <Button onClick={fetchNextPage}>View more</Button>
                    </Box>
                  ) : (
                    ""
                  )}
                </List>
              ) : // </PerfectScrollbar>
              search?.length ||
                notificationTypeList?.length ||
                date?.startDate?.length ||
                date?.endDate?.length ? (
                <Box className={styles.filterNoResult}>
                  <FilterNoResultIcon />
                  <Typography variant="body1">
                    We couldn't find any matches for the selected filter(s).
                  </Typography>
                  <Button>Reset filters</Button>
                </Box>
              ) : (
                <Stack className={`${styles.noItems} ${styles.archivenoItems}`}>
                  <ArchiveNoItemicon />
                  <Typography variant="body1">
                    No archived notifications found.
                  </Typography>
                </Stack>
              )}
              {/* ====================================== */}
              {/* =========== NO ITEMS START =========== */}
              {/* ====================================== */}

              {/* ====================================== */}
              {/* ============ NO ITEMS END ============ */}
              {/* ====================================== */}
            </TabPanel>
          </Paper>
        </Box>
      </PerfectScrollbar>

      {/* ======================================================= */}
      {/* ============ FILTER RESULT NOT FOUND START ============ */}
      {/* ======================================================= */}

      {/*  */}

      {/* ======================================================= */}
      {/* ============= FILTER RESULT NOT FOUND END ============= */}
      {/* ======================================================= */}

      {/* ============================================= */}
      {/* ============ FILTER RESULT START ============ */}
      {/* ============================================= */}

      {/* <Box className={styles.filterResult}>
                <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} flexWrap={'wrap'} className={styles.filterResult_header}>
                    <Typography variant='body2'>Filter results for one or more selected filters. <span>1 result</span></Typography>
                    <Button startIcon={<RemoveIcon />}>Remove all</Button>
                </Stack>
                <Box className={styles.filterList}>
                    <PerfectScrollbar className={styles.notificationBodyScroll}>
                        <List className={styles.notifiactionList}>
                            <ListItem className={styles.listStyled}>
                                <Grid container spacing={0} className={styles.overlayBg}>
                                    <Grid item md={9}>
                                        <Stack direction='row' flexWrap='wrap' className={styles.mediaLeft}>
                                            <figure>
                                                <img src={Notiuserbatch} alt='icon' />
                                            </figure>
                                            <Box className={styles.mediaAddress}>
                                                <Typography variant='subtitle1'>QC Agent changed his full name.</Typography>
                                                <List>
                                                    <ListItem>From: full name</ListItem>
                                                    <ListItem>To: full name</ListItem>
                                                </List>
                                                <Typography variant='caption'>Right now</Typography>
                                            </Box>
                                        </Stack>
                                    </Grid>
                                    <Grid item md={3}>
                                        <Stack direction='row' flexWrap='wrap' justifyContent='flex-end' className={styles.mediaRight}>
                                            <Button>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" viewBox="0 0 9 9" fill="none">
                                                    <path d="M1.13543 0.186912L4.49984 3.55132L7.8504 0.200757C7.96906 0.0744877 8.13402 0.00200757 8.3073 0C8.68963 0 8.99956 0.309927 8.99956 0.692266C9.00282 0.863809 8.93518 1.02912 8.81265 1.14916L5.42747 4.49973L8.81265 7.8849C8.92673 7.9965 8.99368 8.14769 8.99956 8.30719C8.99956 8.68952 8.68963 8.99945 8.3073 8.99945C8.1289 9.00686 7.95563 8.93902 7.82963 8.81254L4.49984 5.44813L1.14235 8.80562C1.02418 8.92766 0.86219 8.99744 0.692378 8.99945C0.310039 8.99945 0.000112197 8.68952 0.000112197 8.30719C-0.00314145 8.13564 0.0644929 7.97033 0.187024 7.85029L3.5722 4.49973L0.187024 1.11455C0.0729385 1.00295 0.00599645 0.851763 0.000112197 0.692266C0.000112197 0.309927 0.310039 0 0.692378 0C0.858798 0.00200757 1.01781 0.0690881 1.13543 0.186912Z" fill="#B8B8B8" />
                                                </svg>
                                            </Button>
                                        </Stack>
                                    </Grid>
                                </Grid>
                            </ListItem>

                        </List>
                    </PerfectScrollbar>
                </Box>
            </Box> */}

      {/* ============================================= */}
      {/* ============= FILTER RESULT END ============= */}
      {/* ============================================= */}
    </>
  );
};

export default ManagerNotificationTab;
